module.exports = __webpack_public_path__ + "static/algods-7c4063498e813c249ef7a3acd9690862.jpg";